require('ta-semantic-ui/semantic/dist/components/reset.css');
require('ta-semantic-ui/semantic/dist/components/site.css');
require('ta-semantic-ui/semantic/dist/components/container.css');
require('ta-semantic-ui/semantic/dist/components/segment.css');
require('ta-semantic-ui/semantic/dist/components/message.css');
require('ta-semantic-ui/semantic/dist/components/divider.css');
require('ta-semantic-ui/semantic/dist/components/grid.css');
require('ta-semantic-ui/semantic/dist/components/header.css');
require('styles/App.css');
require('./main.scss');

import React, {Component} from 'react';
import CardsContainer from '../custom/cardsContainer/CardsContainer'
import MastheadComponent from '../masthead/MastheadComponent';
import Title from '../custom/title/Title';
import Header from '../custom/header/Header'
import GeneralContent from '../custom/general-content/GeneralContent'
import TippContent from '../custom/general-content/TippContent'
import RGMContent from '../custom/general-content/RGMContent'

import FeedbackMessage from '../feedbackMessage/feedbackMessage.component.js'
import CopyrightNotice from '../copyrightNotice/CopyrightNotice.component.js'
import TrackingPixel from '../trackingPixel/TrackingPixel'

const propTypes = {
  data: React.PropTypes.array.isRequired,
  content: React.PropTypes.object.isRequired
}

class AppComponent extends Component {
  constructor (props) {
    super(props);
  }
  render() {
    return (
      <div className="index">

          <MastheadComponent  shareUrl={'http://interaktiv.derbund.ch/ext/2016/howtovote/'}
                              shareText={'So wähle ich richtig smart'}/>

          <Header src="http://files.newsnetz.ch/upload//1/0/100525.jpg"/>
          <br />
          <Title  title={this.props.content.title}
                  lead={this.props.content.lead}
                  authors={this.props.content.authors}/>
          
          <div className="ui section divider"></div>
          
          <div className="ui left aligned grid">
              
              <div className="computer tablet only row">
                  <div className="three wide column"></div>
                  <div className="ten wide column">
                      <h4 className="ui header">Das System</h4>
                      <GeneralContent data={this.props.content}/>
                  </div>
                  <div className="three wide column"></div>
              </div>
              
              <div className="mobile only row">
                  <div className="two wide column"></div>
                  <div className="twelve wide column">
                      <h4 className="ui header">Das System</h4>
                      <GeneralContent data={this.props.content}/>
                  </div>
                  <div className="two wide column"></div>
              </div>
            
            </div>
              

          <div className="ui section divider"></div>

          
          <div className="ui left aligned grid">
              
              <div className="computer tablet only row">
                  <div className="three wide column"></div>
                  <div className="ten wide column">
                      <h4 className="ui header">Spezialfall Rot-Grün-Mitte</h4>
                      <RGMContent data={this.props.content}/>
                  </div>
                  <div className="three wide column"></div>
              </div>
              
              <div className="mobile only row">
                  <div className="two wide column"></div>
                  <div className="twelve wide column">
                      <h4 className="ui header">Spezialfall Rot-Grün-Mitte</h4>
                      <RGMContent data={this.props.content}/>
                  </div>
                  <div className="two wide column"></div>
              </div>
            
            </div>

          <div className="ui section divider"></div>

          
          <div className="ui left aligned grid">
              
              <div className="computer tablet only row">
                  <div className="three wide column"></div>
                  <div className="ten wide column">
                      <h4 className="ui header">Tipps, Tricks und Trivia</h4>
                      <TippContent data={this.props.content}/>
                  </div>
                  <div className="three wide column"></div>
              </div>
              
              <div className="mobile only row">
                  <div className="two wide column"></div>
                  <div className="twelve wide column">
                      <h4 className="ui header">Tipps, Tricks und Trivia</h4>
                      <TippContent data={this.props.content}/>
                  </div>
                  <div className="two wide column"></div>
              </div>
            
            </div>
          
          

          <div className="ui section divider"></div>
          
          <div className="ui container">
              <CardsContainer data={this.props.data}/>
          </div>
          
          <FeedbackMessage />
          <CopyrightNotice />
          <TrackingPixel url={'http://www.derbund.ch/bern/kanton/Waehlen-wie-ein-Profi/story/15327897/pixel.gif?nocache=1479226774'} />
      </div>

    );
  }
}

AppComponent.propTypes = propTypes

AppComponent.defaultProps = {};


export default AppComponent;



// WEBPACK FOOTER //
// ./src/components/main/Main.js